/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {AddressVoModel} from './address-vo.model';
import { DateTimeWithTimezoneModel } from '@irian-ro/date-utils';

export class HandoverOfferDtoModel {

  uuid: string | undefined = undefined;

  pickupAddress: AddressVoModel | undefined = undefined;

  offerForPickupHandoverUuid: string | undefined = undefined;

  pickupTimeWindowStart: DateTimeWithTimezoneModel | undefined = undefined;

  pickupTimeWindowEnd: DateTimeWithTimezoneModel | undefined = undefined;

  requestedPickupTimeWindowStart: DateTimeWithTimezoneModel | undefined = undefined;

  requestedPickupTimeWindowEnd: DateTimeWithTimezoneModel | undefined = undefined;

  hasPickupIntervalOverlap: boolean | undefined = undefined;

  deliveryAddress: AddressVoModel | undefined = undefined;

  offerForDeliveryHandoverUuid: string | undefined = undefined;

  deliveryTimeWindowStart: DateTimeWithTimezoneModel | undefined = undefined;

  deliveryTimeWindowEnd: DateTimeWithTimezoneModel | undefined = undefined;

  requestedDeliveryTimeWindowStart: DateTimeWithTimezoneModel | undefined = undefined;

  requestedDeliveryTimeWindowEnd: DateTimeWithTimezoneModel | undefined = undefined;

  hasDeliveryIntervalOverlap: boolean | undefined = undefined;
}
